import {NgModule} from '@angular/core';
import {AutosizeDirective} from './autosize/autosize';
import {TabHiddenDirective} from './tab-hidden/tab-hidden';

@NgModule({
	declarations: [AutosizeDirective,
    TabHiddenDirective],
	imports: [],
	exports: [AutosizeDirective,
    TabHiddenDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/shared/directives/directives.module.ts